"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sortTargetAudience = function (items) {
    var sortedTargetAudience = [{}];
    items.forEach(function (item) {
        switch (item.label) {
            case 'Zwanger':
                sortedTargetAudience[0] = item;
                break;
            case 'Baby':
                sortedTargetAudience[1] = item;
                break;
            case 'Peuter':
                sortedTargetAudience[2] = item;
                break;
            case 'Kleuter':
                sortedTargetAudience[3] = item;
                break;
            case 'Groep 3-8':
                sortedTargetAudience[4] = item;
                break;
            case 'Puber':
                sortedTargetAudience[5] = item;
                break;
            case 'Student / Scholier':
                sortedTargetAudience[6] = item;
                break;
            case 'Werkende':
                sortedTargetAudience[7] = item;
                break;
            case 'Werkeloze':
                sortedTargetAudience[8] = item;
                break;
            case 'Huisman / Huisvrouw':
                sortedTargetAudience[9] = item;
                break;
            case 'Senior':
                sortedTargetAudience[10] = item;
                break;
            case 'Gepensioneerde':
                sortedTargetAudience[11] = item;
                break;
            case 'Bejaarde':
                sortedTargetAudience[12] = item;
                break;
            default:
                sortedTargetAudience.push(item);
                console.log("err; " + item);
        }
    });
    return sortedTargetAudience;
};
exports.default = sortTargetAudience;
